import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const api = {
  getCategories: () => client.get("/categories").then((r) => r.data),
  getBrands: (category) =>
    client.get("/brands", { params: category ? { category } : {} }).then((r) => r.data),
  getProducts: (params = {}) => client.get("/products", { params }).then((r) => r.data),
  getProduct: (slug) => client.get(`/products/${slug}`).then((r) => r.data),
  getRelated: (slug) => client.get(`/products/${slug}/related`).then((r) => r.data),
  getBlogPosts: (params = {}) => client.get("/blog", { params }).then((r) => r.data),
  getBlogPost: (slug) => client.get(`/blog/${slug}`).then((r) => r.data),
  subscribe: (email) => client.post("/newsletter", { email }).then((r) => r.data),
  contact: (data) => client.post("/contact", data).then((r) => r.data),
  applySeller: (data) => client.post("/sellers", data).then((r) => r.data),
};
